import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VDateInput } from 'vuetify/labs/VDateInput'
export default createVuetify({
  components: {
    ...components,
    VDateInput
  },
  directives,
  typography: {
    defaultFontFamily: 'Raleway, sans-serif'
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#e8612f',
          secondary: '#fb923c',
          surface: '#f8fafc',
          background: '#f1f5f9'
        }
      }
    }
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi }
  }
} as any)
